module.exports = __webpack_public_path__ + "static/media/1.791b1982.jpg";